<div class="content">
  <div *ngIf="updateAvailable" class="update-banner">
    New version available!
    <button (click)="updateApp()">Update</button>
  </div>
  <div *ngIf="pwaInstallAvailable">
    <button button color="primary" (click)="installPwa()"  class="update-banner">
      Install App
    </button>
  </div>
  <router-outlet></router-outlet> 

  <!-- Offline indicator -->
  <app-offline-indicator></app-offline-indicator>
</div>


<!-- <app-login-container></app-login-container> -->